import ENUM from '../../consts/enum';
import ROUTES_NAME from '../../consts/routes-name';

export function getFurtherPageWithStatus(statusCotacao, codigoCotacao) {
    let route = null;
    if (statusCotacao === ENUM.STATUS_COTACAO.PROPOSTA_FINALIZADA) {
        route = ROUTES_NAME.SOLICITACAO_CONTRATACAO;
    } else if (statusCotacao === ENUM.STATUS_COTACAO.PROPOSTA_INICIADA) {
        route = ROUTES_NAME.CONTRATACAO;
    } else if (codigoCotacao) {
        route = ROUTES_NAME.LISTA_BENS;
    } else {
        route = ROUTES_NAME.DADOS_CLIENTE;
    }
    return route;
}
